  // src/api/escpos-image.js
  import html2canvas from 'html2canvas';

  // Bixolon SRP-330III: 203 DPI, 72mm imprimible = 576 dots de ancho
  const PRINTER_WIDTH_DOTS = 576;

  export async function htmlToESCPOS(element) {
    const canvas = await html2canvas(element, {
      scale: 2,
      useCORS: true,
      allowTaint: true,
      backgroundColor: '#ffffff',
      logging: false,
      width: element.offsetWidth,
      windowWidth: element.offsetWidth,
      height: element.scrollHeight,
      windowHeight: element.scrollHeight,
    });

    // ← NO escalar a 576, usar el canvas directo
    // Solo asegurarse que no exceda el ancho de la impresora
    const finalCanvas = document.createElement('canvas');
    const ratio = canvas.width > PRINTER_WIDTH_DOTS 
      ? PRINTER_WIDTH_DOTS / canvas.width 
      : 1; // si ya cabe, no escalar

    finalCanvas.width  = Math.min(canvas.width, PRINTER_WIDTH_DOTS);
    finalCanvas.height = Math.round(canvas.height * ratio);

    const ctx = finalCanvas.getContext('2d');
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, finalCanvas.width, finalCanvas.height);
    ctx.drawImage(canvas, 0, 0, finalCanvas.width, finalCanvas.height);

    const imageData = ctx.getImageData(0, 0, finalCanvas.width, finalCanvas.height);
    const { data, width, height } = imageData;

    const ESC = 0x1B;
    const GS  = 0x1D;
    const bytes = [];

    bytes.push(ESC, 0x40);
    bytes.push(ESC, 0x61, 0x01);

    const bytesPerRow = Math.ceil(width / 8);
    const xL = bytesPerRow & 0xFF;
    const xH = (bytesPerRow >> 8) & 0xFF;
    const yL = height & 0xFF;
    const yH = (height >> 8) & 0xFF;

    bytes.push(GS, 0x76, 0x30, 0x00, xL, xH, yL, yH);

    for (let y = 0; y < height; y++) {
      for (let bx = 0; bx < bytesPerRow; bx++) {
        let byte = 0;
        for (let bit = 0; bit < 8; bit++) {
          const x = bx * 8 + bit;
          if (x < width) {
            const idx = (y * width + x) * 4;
            const r = data[idx];
            const g = data[idx + 1];
            const b = data[idx + 2];
            const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
            if (luminance < 128) {
              byte |= (0x80 >> bit);
            }
          }
        }
        bytes.push(byte);
      }
    }

    bytes.push(ESC, 0x64, 0x04);
    bytes.push(GS, 0x56, 0x41, 0x03);

    return new Uint8Array(bytes);
  }